import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function TwitchIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'Twitch',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30,30,30,.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Twitch</title>

			<rect width="40" height="40" rx="8" fill={bg} />

			<g transform="translate(27 13) scale(0.075 -0.065)">
				{/* Bubble */}
				<path
					d="M44.5-153.1-10.4-208h-86.2l-47-47v47h-70.5V19.3H44.5zm-290 203.8L-261.2-12v-282.1h70.5v-39.2h39.2l39.2 39.2h62.7L75.8-168.7V50.7z"
					fill={g}
				/>

				{/* Left eye */}
				<rect x="-115" y="-125" width="32" height="100" fill={g} />

				{/* Right eye */}
				<rect x="-45" y="-125" width="32" height="100" fill={g} />
			</g>
		</svg>
	);
}
